import { render, staticRenderFns } from "./ActiveBody.vue?vue&type=template&id=3bb7f877&scoped=true&"
import script from "./ActiveBody.vue?vue&type=script&lang=ts&"
export * from "./ActiveBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7f877",
  null
  
)

export default component.exports